import { Form } from 'antd';
import FormLayout from './FormLayout';
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { CASE_FORM_TYPES } from '../../../appContants';
import {
  mapAntFileToServerFile,
  mapCaseToPatientDetails,
  mapCaseToServices,
  mapCaseToStudyPurpose,
  mapCaseToUpload,
  mapPatientDetailsToCase,
  mapServicesToCase,
  mapStudyPurposeToCase,
} from '../../../utils/case';

const CaseForm = ({
  initialValues,
  loading,
  onSubmit,
  breadCrumbs,
}) => {
  const layoutRef = useRef();
  const formDataRef = useRef({});
  const [patientDetailsForm] = Form.useForm();
  const [studyPurposeForm] = Form.useForm();
  const [addServiceForm] = Form.useForm();
  const [uploadFilesForm] = Form.useForm();

  useEffect(() => {
    if (!initialValues) return;

    // Map Case details to input form values
    const initialPatientDetails = mapCaseToPatientDetails(initialValues);
    const initialStudyPurpose = mapCaseToStudyPurpose(initialValues);
    const initialServices = mapCaseToServices(initialValues);
    const initialUploads = mapCaseToUpload(initialValues);

    // initialize forms with case input data
    initialPatientDetails &&
      patientDetailsForm.setFieldsValue(initialPatientDetails);
    initialStudyPurpose && studyPurposeForm.setFieldsValue(initialStudyPurpose);
    initialServices && addServiceForm.setFieldsValue(initialServices);
    initialUploads && uploadFilesForm.setFieldsValue(initialUploads);
  }, [initialValues]);

  const updateFormDataRef = (name, info) => {
    switch (name) {
      case CASE_FORM_TYPES.patientDetails:
        formDataRef.current = {
          ...(formDataRef?.current || {}),
          ...mapPatientDetailsToCase(info?.values),
        };
        break;
      case CASE_FORM_TYPES.addServices:
        formDataRef.current = {
          ...(formDataRef?.current || {}),
          ...mapServicesToCase(info?.values?.services),
        };
        break;
      case CASE_FORM_TYPES.uploadFiles:
        formDataRef.current = {
          ...(formDataRef?.current || {}),
          files: info?.values?.files?.map(mapAntFileToServerFile),
        };
        break;
      case CASE_FORM_TYPES.studyPurpose:
        formDataRef.current = {
          ...(formDataRef?.current || {}),
          studyPurpose: {
            ...(mapStudyPurposeToCase(info?.values) || {}),
          },
        };
        break;

      default:
        break;
    }
  };
  return (
    <Form.Provider
      onFormFinish={(name, info) => {
        // Update the form data ref with latest form values received
        updateFormDataRef(name, info);
        if (name === CASE_FORM_TYPES.uploadFiles) {
          return onSubmit?.(formDataRef.current);
        } else {
          layoutRef?.current?.goToNextTab();
        }
      }}
    >
      <FormLayout
        ref={layoutRef}
        patientDetailsForm={patientDetailsForm}
        studyPurposeForm={studyPurposeForm}
        addServiceForm={addServiceForm}
        uploadFilesForm={uploadFilesForm}
        loading={loading}
        initialValues={initialValues}
        breadCrumbs={breadCrumbs}
      />
    </Form.Provider>
  );
};

CaseForm.propTypes = {
  initialValues: PropTypes.any,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func,
  breadCrumbs: PropTypes.array,
};

export default CaseForm;
